import type { CompanyFilter } from '../lib/companyFilter.ts';
import { SearchableMultiSelect } from './SearchableMultiSelect.tsx';

export type FilterBarOptions = {
  contractorTypes: string[];
  clusterRegions: string[];
  stations: string[];
};

/**
 * Reusable filter bar for the admin Dashboard and Expiring Documents views.
 * Renders three searchable multi-select dropdowns (contractor type, cluster
 * region, station) plus a "Clear all filters" button. State is fully controlled —
 * the parent owns the CompanyFilter value and passes onChange.
 */
export function FilterBar({
  options,
  value,
  onChange,
}: {
  options: FilterBarOptions;
  value: CompanyFilter;
  onChange: (next: CompanyFilter) => void;
}) {
  const hasAny =
    value.contractorTypes.length > 0 ||
    value.clusterRegions.length > 0 ||
    value.stations.length > 0;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <SearchableMultiSelect
        label="Contractor type"
        unitLabel="contractor types"
        values={options.contractorTypes}
        selected={value.contractorTypes}
        onChange={(next) => onChange({ ...value, contractorTypes: next })}
      />
      <SearchableMultiSelect
        label="Cluster region"
        unitLabel="cluster regions"
        values={options.clusterRegions}
        selected={value.clusterRegions}
        onChange={(next) => onChange({ ...value, clusterRegions: next })}
      />
      <SearchableMultiSelect
        label="Station"
        unitLabel="stations"
        values={options.stations}
        selected={value.stations}
        onChange={(next) => onChange({ ...value, stations: next })}
      />
      {hasAny && (
        <button
          type="button"
          className="rounded-md px-3 py-2 text-sm text-slate-500 hover:bg-slate-100 hover:text-slate-700"
          onClick={() => onChange({ contractorTypes: [], clusterRegions: [], stations: [] })}
        >
          Clear all filters
        </button>
      )}
    </div>
  );
}
